import { combineEpics } from 'redux-observable'
import { createListable } from 'listable'
import options from './config'
import { createEffects } from './effects'
import * as customActions from './actions'
import { moduleName } from './actions/types'
import customReducer from './reducer'


const listableModule = createListable({
  name: moduleName,
  config: options,
  customActions,
  customReducer,
})

export const config = listableModule.options
export const actions = listableModule.actions

export const effects = combineEpics(
  createEffects(listableModule.actions),
  listableModule.effects,
)

export const name = listableModule.name
export const reducer = listableModule.reducer
export const types = listableModule.types

export const constants = {
  ...listableModule.constants,
  PATH_ALL: `/ruc-requests`,
  PATH_ADD: `/ruc-requests/new`,
  PATH_SINGLE: `/ruc-requests/booking`,
  ROUTE_ALL: `/ruc-requests`,
  ROUTE_ADD: `/ruc-requests/new`,
  ROUTE_SINGLE: `/ruc-requests/booking/:id`,
}

export const createDefaultModel = () => ({
  effectiveDate: null,
  status: 'requested',
})
